module.exports = __webpack_public_path__ + "static/media/freight.1a6fa6f1.svg";